import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=4488c4f2&scoped=true&"
import script from "./indexTwo.vue?vue&type=script&lang=js&"
export * from "./indexTwo.vue?vue&type=script&lang=js&"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=4488c4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488c4f2",
  null
  
)

export default component.exports